var r = function r(_r) {
  var a = {};
  for (var t in _r) /^aria/.test(t) && (a[t] = _r[t]);
  return a;
};
export { r as extractAriaProps };